import { render } from "./DailyGameReporting.vue?vue&type=template&id=64e0dfce&scoped=true"
import script from "./DailyGameReporting.vue?vue&type=script&lang=js"
export * from "./DailyGameReporting.vue?vue&type=script&lang=js"

import "./DailyGameReporting.vue?vue&type=style&index=0&id=64e0dfce&scoped=true&lang=postcss"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e0dfce"]])

export default __exports__